import request from '../../../common/request/index.js'
const api = request.api

export default {
  // ==================== 通用 CRUD ====================
  /**
   * 获取订单详情
   */
  get: async (id) => {
    return api.get(`order/order/${id}`)
  },

  /**
   * 分页查询订单列表
   * @param {Object} data - { current, pageSize, order_no, status, refund_status, startTime, endTime, ... }
   */
  page: async (data) => {
    return api.post(`order/order/page`, data)
  },

  search: async (data) => {
    return api.post(`order/order/search`, data)
  },

  put: async (data) => {
    return api.put(`order/order`, data)
  },

  post: async (data) => {
    return api.post(`order/order`, data)
  },

  del: async (id) => {
    return api.delete(`order/order/${id}`)
  },
  
  /**
     * 主动查单同步状态
     * @param {String} orderNo 
     */
    queryStatus: (orderNo) => {
      return api.get(`order/order/queryStatus/${orderNo}`)
    },

  // ==================== 退款流程 ====================
  /**
   * 站点负责人提交退款申请（不直接退款，走审批流）
   * @param {Object} data - { order_no, refundReason }
   */
  refundApply: async (data) => {
    return api.post(`order/order/refund/apply`, data)
  },

  /**
   * 管理员审批通过退款申请
   * @param {Object} data - { order_no }
   */
  refundApprove: async (data) => {
    return api.post(`order/order/refund/approve`, data)
  },

  /**
   * 管理员拒绝退款申请
   * @param {Object} data - { order_no, rejectReason }
   */
  refundReject: async (data) => {
    return api.post(`order/order/refund/reject`, data)
  },

  /**
   * 执行退款（仅当订单 refund_status === 'approved' 时可调用）
   * @param {Object} data - { order_no, refundReason }
   */
  refund: async (data) => {
    // 兼容旧调用方式：传字符串只当作 orderNo
    const payload = typeof data === 'string'
      ? { order_no: data }
      : (data || {})
    return api.post(`order/order/refund`, payload)
  },

  // ==================== 数据统计 ====================
  /**
   * 获取今日/昨日统计数据
   * @param {Object} params - { enterpriseId, stationId }
   */
  statistics: (params) => {
    return api.post(`order/order/statistics`, params)
  },

  /**
   * 获取日实付趋势
   * @param {Object} params - { enterpriseId, stationId, days }
   */
  trend: (params) => {
    return api.post(`order/order/trend`, params)
  },

  /**
   * 获取今日订单实付排名
   * @param {Object} params - { enterpriseId, stationId, limit }
   */
  rank: (params) => {
    return api.post(`order/order/rank`, params)
  },

  // ==================== 导出 ====================
  /**
   * 导出订单数据
   * @param {Object} params - { fields, scope, page, pageSize, fileName, searchParams }
   */
  export: (params) => {
    return api.post('order/order/export', params, { responseType: 'blob' })
  },
}